<script setup>
import {ref, computed} from "vue";

const cards1 = ref([
  {
    id: 1,
    photo: require("@/assets/9may/slides/slide1.jpg"),
    title: "Начало традиции военных салютов",
    description:
      "5 августа 1943 г. в Москве впервые прозвучал артиллерийский салют в честь освобождения Орла и Белгорода. 124 орудия произвели 12 залпов, ознаменовав первую крупную победу Красной армии.​",
    info: "Салют Победы над Красной площадью.  <br> Москва. 9 мая 1945 г. <br> Фото Л.М. Доренского. <br>Главархив Москвы",
  },
  {
    id: 2,
    photo: require("@/assets/9may/slides/slide2.webp"),
    title: "Категории военных салютов в 1943 г.",
    description:
      "В 1943 году были установлены три степени салютов: <br>Первая степень: 24 залпа из 324 орудий — в честь освобождения столиц союзных республик и завершения войны.<br>Вторая степень: 20 залпов из 224 орудий — в честь освобождения крупных городов <br> и завершения крупных операций.<br>Третья степень: 12 залпов из 124 орудий — в честь освобождения важных пунктов <br> и узлов дорог.​",
    info: "Салют Победы. <br> Москва. 9 мая 1945 г.<br> Фото Я. Халипа. <br> Главархив Москвы",
  },
  {
    id: 3,
    photo: require("@/assets/9may/slides/slide3.webp"),
    title: "Первый салют Победы 9 мая 1945 г.",
    description:
      "9 мая 1945 г. в Москве прогремел грандиозный салют: 1000 орудий дали 30 залпов. Дополнительные визуальные эффекты обеспечили перекрестные лучи 160 прожекторов и запуск разноцветных ракет.",
    info: "Салют Победы. <br> Москва. 9 мая 1945 г.<br> Фото С.И. Лоскутова. <br>Главархив Москвы",
  },
  {
    id: 4,
    photo: require("@/assets/9may/slides/slide4.webp"),
    title: "Салюты в послевоенные годы",
    description:
      "После Великой Отечественной войны традиция салютов сохранилась. Праздничные мероприятия проводились 9 мая в Москве, Ленинграде, столицах союзных республик <br> и городах-героях.​",
    info: "Праздничный салют в День Победы.<br> Москва. 9 мая 1965 г.<br> Фото В.В. Ахломова. <br> Главархив Москвы",
  },
  {
    id: 5,
    photo: require("@/assets/9may/slides/slide5.jpg"),
    title: "Современные салюты в День Победы",
    description:
      "Сегодня салюты в честь Дня Победы продолжают традицию чествования подвига народа. Ежегодные салюты 9 мая символизируют благодарность ветеранам и сохраняют память о Великой Отечественной войне, передавая традицию новым поколениям.​",
  },
]);

const isModalOpen = ref(false);
const currentIndex = ref(0);

const selectedCard = computed(() => cards1.value[currentIndex.value]);

const openModal = (card) => {
  const index = cards1.value.findIndex((c) => c.id === card.id);
  if (index !== -1) {
    currentIndex.value = index;
    isModalOpen.value = true;
  }
};

const closeModal = () => {
  isModalOpen.value = false;
};

const showPrevCard = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  } else {
    currentIndex.value = cards1.value.length - 1; // круговое переключение
  }
};

const showNextCard = () => {
  if (currentIndex.value < cards1.value.length - 1) {
    currentIndex.value++;
  } else {
    currentIndex.value = 0; // круговое переключение
  }
};
</script>

<template>
  <div class="information">
    <div class="information-fill container">
      <div class="information-caption">
        <p class="information__title">История салютов Победы</p>
      </div>
      <div class="cards">
        <div v-for="item in cards1" :key="item.id" class="card">
          <div class="card-photo">
            <img :src="item.photo" alt="" class="card-photo__content" />
            <div class="card-info" v-if="item.info">
              <img
                src="@/assets/9may/material-symbols_info-outline.svg"
                alt=""
                class="card-info__icon" />
              <p class="card-info__text" v-html="item.info"></p>
            </div>
          </div>
          <p class="card__title">{{ item.title }}</p>
          <button class="link card__link" @click="openModal(item)">
            Подробнее
          </button>
        </div>
        <div
          v-if="isModalOpen"
          @click.self="closeModal"
          class="cards-model shell">
          <div class="cards-model__content modal">
            <div class="card-photo">
              <img
                :src="selectedCard.photo"
                alt=""
                class="card-photo__content" />
              <button class="close" @click="closeModal">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_6522_810)">
                    <rect width="28" height="28" rx="14" fill="white" />
                    <path
                      d="M14 0C6.2 0 0 6.2 0 14C0 21.8 6.2 28 14 28C21.8 28 28 21.8 28 14C28 6.2 21.8 0 14 0ZM19.4 21L14 15.6L8.6 21L7 19.4L12.4 14L7 8.6L8.6 7L14 12.4L19.4 7L21 8.6L15.6 14L21 19.4L19.4 21Z"
                      fill="#D72D41" />
                  </g>
                  <defs>
                    <clipPath id="clip0_6522_810">
                      <rect width="28" height="28" rx="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
            <p class="card__title">{{ selectedCard.title }}</p>
            <p class="card__text" v-html="selectedCard.description"></p>
            <div class="nav">
              <button
                class="nav__button nav__button--prev"
                @click="showPrevCard">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.29279 12.7073C8.10532 12.5198 8 12.2655 8 12.0003C8 11.7352 8.10532 11.4809 8.29279 11.2933L13.9498 5.63634C14.042 5.54083 14.1524 5.46465 14.2744 5.41224C14.3964 5.35983 14.5276 5.33225 14.6604 5.33109C14.7932 5.32994 14.9248 5.35524 15.0477 5.40552C15.1706 5.4558 15.2823 5.53006 15.3762 5.62395C15.4701 5.71784 15.5443 5.82949 15.5946 5.95239C15.6449 6.07529 15.6702 6.20696 15.669 6.33974C15.6679 6.47252 15.6403 6.60374 15.5879 6.72575C15.5355 6.84775 15.4593 6.9581 15.3638 7.05034L10.4138 12.0003L15.3638 16.9503C15.5459 17.1389 15.6467 17.3915 15.6445 17.6537C15.6422 17.9159 15.537 18.1668 15.3516 18.3522C15.1662 18.5376 14.9154 18.6427 14.6532 18.645C14.391 18.6473 14.1384 18.5465 13.9498 18.3643L8.29279 12.7073Z"
                    fill="#828282" />
                </svg>
              </button>
              <button
                class="nav__button nav__button--next"
                @click="showNextCard">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_5085_6434)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.7072 12.7073C15.8947 12.5198 16 12.2655 16 12.0003C16 11.7352 15.8947 11.4809 15.7072 11.2933L10.0502 5.63634C9.95797 5.54083 9.84762 5.46465 9.72562 5.41224C9.60361 5.35983 9.47239 5.33225 9.33961 5.33109C9.20684 5.32994 9.07516 5.35524 8.95226 5.40552C8.82936 5.4558 8.71771 5.53006 8.62382 5.62395C8.52993 5.71784 8.45567 5.82949 8.40539 5.95239C8.35511 6.07529 8.32981 6.20696 8.33096 6.33974C8.33212 6.47252 8.3597 6.60374 8.41211 6.72575C8.46452 6.84775 8.5407 6.9581 8.63621 7.05034L13.5862 12.0003L8.63621 16.9503C8.45406 17.1389 8.35326 17.3915 8.35554 17.6537C8.35782 17.9159 8.46299 18.1668 8.64839 18.3522C8.8338 18.5376 9.08462 18.6427 9.34681 18.645C9.60901 18.6473 9.86161 18.5465 10.0502 18.3643L15.7072 12.7073Z"
                      fill="#828282" />
                  </g>
                  <defs>
                    <clipPath id="clip0_5085_6434">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="matrix(-1 0 0 1 24 0)" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.information {
  margin-top: 60px;
  &-caption {
    display: flex;
    align-items: flex-end;
  }
  &__title {
    font-weight: 500;
    font-size: 3rem;
    line-height: 112%;
    color: #0a0033;
  }

  .cards {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 32px;
    column-gap: 32px;
    justify-content: center;
    &-model {
      background: none;
      z-index: 13;
      &__content {
        background: #f0f2f6;
        border-radius: 56px;
        max-width: 1117px;
        width: 100%;
        position: relative;
      }
      .close {
        position: absolute;
        z-index: 1;
        right: 18px;
        top: 12px;
      }
      .card-photo {
        padding-bottom: 36.7%;
      }
      .card__title {
        margin-top: 38px;
        font-weight: 500;
        font-size: 32px;
        line-height: 130%;
        letter-spacing: 0.01em;
        color: #000;
        margin-bottom: 0;
      }
      .card__text {
        margin-top: 15px;
        font-weight: 400;
        font-size: 24px;
        line-height: 133%;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
  .card {
    padding: 24px 16px;
    background: #f0f2f6;
    border-radius: 32px;
    height: unset;
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 360px;
    max-width: 443px;
    &:nth-child(3) {
      .card-info__text {
        width: 180px;
      }
    }
    &:nth-child(2) {
      .card-info__text {
        width: 180px;
      }
    }
    &-photo {
      border-radius: 32px;
      width: 100%;
      position: relative;
      padding-bottom: 50%;
      &__content {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 32px;
        object-fit: cover;
      }
    }
    &__title {
      margin-top: 11px;
      font-weight: 500;
      font-size: 20px;
      line-height: 130%;
      letter-spacing: 0.01em;
      color: #000;
      margin-bottom: 37px;
    }
    &__link {
      margin-top: auto;
      padding: 9px;
      font-size: 16px;
    }
    &-info {
      position: absolute;
      bottom: 20px;
      left: 20px;
      display: flex;
      &__text {
        position: absolute;
        bottom: 30px;
        background-color: #ffffff;
        left: 0;
        border-radius: 10px;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
        width: 280px;
        padding: 7px;
        font-size: 14px;
        transition: all 0.5s ease-in-out;
        opacity: 0;
        display: inline-flex;
      }
      &__icon {
        &:hover ~ .card-info__text {
          opacity: 1;
        }
      }
    }
  }

  @media (max-width: 1100px) {
    margin-top: 46px;
    &__link {
      padding: 0.875rem 1.25rem;
      background: #d72d41;
      color: #fff;
      font-size: 1rem;
      flex-shrink: 0;
    }
    &__title {
      font-size: 24px;
      line-height: 130%;
      font-weight: 700;
    }
    .card {
      &__title {
        font-size: 16px;
        margin-bottom: 26px;
      }
    }
    .cards {
      &-model {
        &__content {
          border-radius: 24px;
          border: 1px solid #000;
        }
        .close {
          right: 12px;
          top: 12px;
          width: 24px;
          height: 24px;
          display: flex;
        }
        .card-photo {
          padding-bottom: 70%;
        }
        .card__title {
          margin-top: 16px;
          font-size: 22px;
        }
        .card__text {
          margin-top: 12px;
          font-size: 16px;
        }
      }
    }
  }

  .cards {
    gap: 16px;
  }

  .card {
    width: 100%;
  }
}

.nav {
  position: absolute;
  width: calc(100% + 128px);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: -64px;
  top: 0;
  z-index: 11;
  pointer-events: none;
  &__button {
    width: 48px;
    height: 48px;
    background: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
    pointer-events: all;
  }
  @media (max-width: 1100px) {
    justify-content: center;
    align-items: flex-end;
    top: 52px;
    gap: 12px;
    width: 100%;
    left: 0;
    &__button {
      width: 32px;
      height: 32px;
    }
  }
}

.link {
  margin-top: 60px;
  width: 100%;
  justify-content: center;
}
</style>
